<template>
<div>
    <v-card tile overflow-hidden :key=dialog>
        <div v-if="mandat_dialog!=null&&mandat_dialog!={}">
        <v-toolbar card prominent>
            <v-toolbar-title class="text-uppercase primary--text"><span>{{ mandat_dialog.type_bien }}<span> </span><span v-if="mandat_dialog.nombre_piece!=0"> {{ mandat_dialog.nombre_piece }} pièces 
                </span> - {{ mandat_dialog.prix }} €</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-if="edit==true" flat icon color="primary" @click="enable_edit()"><v-icon>edit</v-icon></v-btn>
            <v-btn v-if="edit==false" flat icon color="primary" @click="save_edit()"><v-icon>save_alt</v-icon></v-btn>
            <v-btn flat icon color="primary" @click="closeDialog()"><v-icon>close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text overflow-hidden>
            <v-form>
            <v-container fluid overflow-hidden>
                <v-layout row wrap overflow-hidden>


                    <!-- colonne 1--> 


                    <v-flex sm12 md4 px-3>
                        <v-card tile>
                            <v-carousel height="400px" v-model="carrousselIndex" :cycle="false" :key="mandat_dialog.photos">
                                <v-carousel-item v-if="mandat_dialog.photos.length==0" src="https://vignette.wikia.nocookie.net/mario-kart-fanon/images/d/d3/No-picture.jpg/revision/latest?cb=20151202231035&path-prefix=fr"></v-carousel-item>
                                <div v-if="mandat_dialog.photos.length>0">
                                    <v-carousel-item v-for="photo in mandat_dialog.photos" :key="photo.id" :src="photo.photo"></v-carousel-item>
                                </div>
                            </v-carousel>
                            <v-card tile class="text-xs-center text-sm-center text-md-center text-lg-center" v-if="!edit">
                                <v-btn icon color="red darken-2" :disabled="mandat_dialog.photos.length==0" @click='delete_dialog=true' :dark="mandat_dialog.photos.length!=0"><v-icon>delete</v-icon></v-btn>
                                <v-btn icon color="green darken-2" @click='pickFile'  dark><v-icon>add</v-icon></v-btn>
                                <v-btn :disabled="carrousselIndex==0" @click="photo_move_l" icon color="blue darken-2" :dark="carrousselIndex!=0"><v-icon>chevron_left</v-icon></v-btn>
                                <v-btn :disabled="carrousselIndex>=mandat_dialog.photos.length-1" @click="photo_move_r" icon color="blue darken-2" :dark="carrousselIndex<mandat_dialog.photos.length-1"><v-icon>chevron_right</v-icon></v-btn>

                                <v-text-field :label="'Select Image ' + carrousselIndex" @click='pickFile' prepend-icon='attach_file'></v-text-field>
                                <input
                                    type="file"
                                    style="display: none"
                                    ref="image"
                                    accept="image/*"
                                    @change="onFilePicked"
                                >
                            </v-card>
                        </v-card>
                        
                        <v-card tile>
                            <v-card-title class="text-uppercase secondary--text">description</v-card-title>
                            <v-card-text > 
                            <v-textarea v-model="mandat_dialog.description" :disabled=edit auto-grow></v-textarea>
                            </v-card-text>
                        </v-card>

                        <v-card tile>
                        <v-card-title class="text-uppercase secondary--text">général</v-card-title>
                            <v-card-text>
                                <v-layout row wrap>
                                <v-flex xs6 md6 px-1><v-combobox v-model="mandat_dialog.type_bien" :items="types_biens" label="Type de bien" :disabled=edit></v-combobox></v-flex>
                                <v-flex xs6 md6 px-1><v-combobox v-model="mandat_dialog.status" :items="types_mandats" label="Type de mandat" :disabled=edit></v-combobox></v-flex>
                                <v-flex xs6 md6 px-1><v-switch v-if="!edit" v-model="mandat_dialog.en_copro" label="En Copropriété" :disabled=edit></v-switch>
                                <v-text-field v-if=edit :disabled="true" :value="mandat_dialog.en_copro ? 'Oui' : 'Non'" label="En Copropriété"></v-text-field></v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>   
                    </v-flex>




                    <!-- colonne 2-->


                    <v-flex sm12 md4 px-3>  

                                                   
                            <v-card tile>
                            <v-card-title class="text-uppercase secondary--text">aspect financier</v-card-title>
                            <v-card-text>
                                <v-layout row wrap>
                                    <v-flex xs6 md6 px-1><v-text-field v-model="mandat_dialog.prix" :mask=mask_prix label="Prix de vente" :disabled=edit suffix="€"></v-text-field></v-flex>
                                    
                                    <v-flex xs6 md6 px-1><v-text-field :rules=rule_price :value="Math.round(mandat_dialog.prix*0.0299)" label="Honoraires" :disabled=edit :readonly="!edit"  suffix="€"></v-text-field></v-flex>
                                    <v-flex xs6 md6 px-1><v-text-field v-model="mandat_dialog.taxe_fonciere" :mask=mask_prix label="Taxe foncière" :disabled=edit suffix="€/an"></v-text-field></v-flex>
                                    <v-flex v-if="mandat_dialog.en_copro==true" xs6 md6 px-1><v-text-field v-model="mandat_dialog.charges_copro_mens" :mask=mask_prix label="Charges copropriété" :disabled=edit suffix="€/mois"></v-text-field></v-flex>
                                    <v-flex v-if="mandat_dialog.en_copro==true" xs6 md6 px-1   ><v-text-field v-model="mandat_dialog.charges_annuelles_alur" :mask=mask_prix label="Charges ALUR" :disabled=edit suffix="€/an"></v-text-field></v-flex>
                                </v-layout>
                            </v-card-text>
                            </v-card>



                            <v-card tile v-if="mandat_dialog.en_copro==true">
                            <v-card-title class="text-uppercase secondary--text">Copropriété</v-card-title>
                            <v-card-text>
                                <v-layout row wrap>
                                    <v-flex xs6 md6 px-1><v-combobox v-model="mandat_dialog.procedures" :items="listeProcedures" label="Procédures en cours" :disabled=edit ></v-combobox></v-flex>
                                    <v-flex xs6 md6 px-1><v-text-field v-model="mandat_dialog.nombre_lots_copro" label="Nombre de lots copro" :mask=mask_number :disabled=edit :type="edit ? '' : 'number'"></v-text-field></v-flex>
                                    <v-flex xs6 md6 px-1><v-text-field v-model="mandat_dialog.nombre_lots_habitation" label="Nombre de lots habitation" :mask=mask_number :disabled=edit :type="edit ? '' : 'number'"></v-text-field></v-flex>
                                </v-layout>
                            </v-card-text>
                            </v-card>

                            <v-card tile v-if="mandat_dialog.type_bien!='Appartement'">
                            <v-card-title class="text-uppercase secondary--text">Extérieur</v-card-title>
                            <v-card-text>
                                    <v-layout row wrap>
                                        <v-flex xs6 md6 px-1><v-text-field v-model="mandat_dialog.surface_terrain" label="Surface terrain" suffix="m²" :mask=mask_number :disabled=edit :type="edit ? '' : 'number'"></v-text-field></v-flex>
                                        <v-flex xs6 md6 px-1 v-if="mandat_dialog.type_bien!='Terrain'"><v-switch v-if="!edit" v-model="mandat_dialog.jardin" label="jardin" :disabled=edit></v-switch>
                                        <v-text-field v-if=edit :disabled="true" :value="mandat_dialog.jardin ? 'Oui' : 'Non'" label="Jardin"></v-text-field></v-flex>
                                    </v-layout>
                            </v-card-text>
                            </v-card >
            
                            <v-card tile v-if="mandat_dialog.type_bien!='Terrain'">
                            <v-card-title class="text-uppercase secondary--text">Interieur</v-card-title>
                            <v-card-text>
                                <v-layout row wrap>
                                    <v-flex xs6 md6 px-1><v-text-field v-model="mandat_dialog.surface_logement" :mask=mask_number label="Surface" suffix="m²" :disabled=edit :type="edit ? '' : 'number'"></v-text-field></v-flex>
                                    <v-flex xs6 md6 px-1><v-combobox v-model="mandat_dialog.mode_chauffage" :items="modes_chauffage" label="Mode de chauffage" :disabled=edit ></v-combobox></v-flex>
                                    <v-flex xs6 md6 px-1><v-combobox v-model="mandat_dialog.type_chauffage" :items="types_chauffage" label="Type de chauffage" :disabled=edit ></v-combobox></v-flex>
                                    <v-flex xs12>
                                        <v-expansion-panel>
                                        <v-expansion-panel-content>
                                        <template v-slot:header><span class="font-weight-medium">Détail des pièces</span></template>

                                                <v-data-table :headers="piece_headers" :items="mandat_dialog.piece_associe" class="elevation-1">
                                                <template v-slot:no-data>
                                                <v-alert :value="true" color="error" icon="warning">
                                                Pas de pièces renseignées pour ce bien
                                                </v-alert>
                                            </template>
                                                </v-data-table>
                                        </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                            </v-card>
                   
                            <v-card tile>
                            <v-card-title class="text-uppercase secondary--text">Autres</v-card-title>
                            <v-card-text>
                                <v-layout row wrap>
                                    
                                    <v-flex xs6 md6 px-1><v-switch v-if="!edit" v-model="mandat_dialog.ascenseur" label="Ascenseur" :disabled=edit></v-switch>
                                        <v-text-field v-if=edit :disabled="true" :value="mandat_dialog.ascenseur ? 'Oui' : 'Non'" label="Ascenseur"></v-text-field></v-flex>
                                    <v-flex xs6 md6 px-1><v-switch v-if="!edit" v-model="mandat_dialog.cave" label="Cave" :disabled=edit></v-switch>
                                        <v-text-field v-if=edit :disabled="true" :value="mandat_dialog.cave ? 'Oui' : 'Non'" label="Cave"></v-text-field></v-flex>
                                    <v-flex xs6 md6 px-1><v-switch v-if="!edit" v-model="mandat_dialog.grenier" label="Grenier" :disabled=edit></v-switch>
                                        <v-text-field v-if=edit :disabled="true" :value="mandat_dialog.grenier ? 'Oui' : 'Non'" label="Grenier"></v-text-field></v-flex>
                                        <v-flex xs6 md6 px-1><v-switch v-if="!edit" v-model="mandat_dialog.servitude" label="Servitude" :disabled=edit></v-switch>
                                        <v-text-field v-if=edit :disabled="true" :value="mandat_dialog.servitude ? 'Oui' : 'Non'" label="Servitude"></v-text-field></v-flex>
                                    <v-flex xs6 md6 px-1><v-text-field v-model="mandat_dialog.nombre_balcon" label="Nombre de balcons" :mask=mask_number :disabled=edit :type="edit ? '' : 'number'"></v-text-field></v-flex>
                                    <v-flex xs6 md6 px-1><v-text-field v-model="mandat_dialog.nombre_stationnement" label="Nombre de stationnements" :mask=mask_number :disabled=edit :type="edit ? '' : 'number'"></v-text-field></v-flex>
                                    <v-flex xs6 md6 px-1 v-if="mandat_dialog.nombre_stationnement!=0"><v-combobox v-model="mandat_dialog.type_stationnement" :items="types_stationnements" label="Type(s) de stationnement" :disabled=edit ></v-combobox></v-flex>
                                </v-layout>
                            </v-card-text>
                            </v-card>
                       

                    </v-flex>
                    <!-- colonne 3-->

                    <v-flex sm12 md4 px-3>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-card tile>
                                <v-card-title class="text-uppercase secondary--text">localisation</v-card-title>
                                <v-card-text>
                                    <v-layout row wrap>
                                        <v-flex xs12 pb-3><div id="map" ref="mymap" style="height: 400px"></div></v-flex>
                                        <v-flex xs6 md6 px-1><v-text-field v-model="mandat_dialog.ville" label="Ville" :disabled=edit></v-text-field></v-flex>
                                        <v-flex xs6 md6 px-1><v-text-field v-model="mandat_dialog.code_postal" label="Code postal" :mask=mask_cp :disabled=edit></v-text-field></v-flex>
                                        <v-flex xs2 md2 px-1><v-text-field v-model="mandat_dialog.numero_rue" label="N°" :mask=mask_number :disabled=edit :type="edit ? '' : 'number'"></v-text-field></v-flex>
                                        <v-flex xs10 md10 px-1><v-text-field v-model="mandat_dialog.rue" label="Rue" :disabled=edit></v-text-field></v-flex>
                                        <v-flex xs6 md12 px-1 v-if="!edit"><v-btn color="primary" @click="updateCoord()">Actualiser</v-btn></v-flex>
                                    </v-layout>
                                </v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex xs12>
                                <v-card tile v-if="mandat_dialog.type_bien!='Terrain'">
                                    <v-card-title class="text-uppercase secondary--text">diagnostique énergétique</v-card-title>
                                    <v-card-text>
                                        <v-layout row wrap>
                                            <v-flex md12 xl6>
                                                <v-card flat>
                                                    <v-card-title class="text-uppercase dark-grey--text">Classe énergétique</v-card-title>
                                                    <v-card-text>
                                                        <v-text-field v-model="mandat_dialog.valeur_energetique" v-if="!edit" :mask=mask_number label="Valeur énergétique"></v-text-field>
                                                        <v-layout column v-if="mandat_dialog.valeur_energetique!=''">
                                                            <v-layout row wrap>
                                                                
                                                                <v-flex xs3>
                                                                <v-card flat color="green"><v-layout row><v-flex pl-1 grow>≤50</v-flex> <v-flex shrink pr-1>A</v-flex></v-layout></v-card>
                                                                </v-flex>
                                                                <v-flex xs2 pl-1>
                                                                <v-card flat dark v-if="mandat_dialog.valeur_energetique<=50  " color="dark-grey"><span style="padding-left:3px">{{mandat_dialog.valeur_energetique}}</span></v-card>
                                                                </v-flex>
                                                            </v-layout> 
                                                            <v-layout row>
                                                                <v-flex xs4 pt-1>
                                                                    <v-card flat color="light-green"><v-layout row><v-flex pl-1 grow>51 à 90</v-flex><v-flex shrink pr-1>B</v-flex></v-layout></v-card>
                                                                </v-flex>
                                                                <v-flex xs2 pl-1 pt-1>
                                                                    <v-card flat dark v-if='mandat_dialog.valeur_energetique>50 && mandat_dialog.valeur_energetique<=90  ' color="dark-grey"><span style="padding-left:3px">{{mandat_dialog.valeur_energetique}}</span></v-card>
                                                                </v-flex> 
                                                            </v-layout>
                                                            <v-layout row>
                                                                <v-flex xs5 pt-1>
                                                                    <v-card flat color="lime"><v-layout row><v-flex pl-1 grow>91 à 150</v-flex><v-flex shrink pr-1>C</v-flex></v-layout></v-card>
                                                                </v-flex>
                                                                <v-flex xs2 pl-1 pt-1>
                                                                    <v-card flat dark  v-if='90<mandat_dialog.valeur_energetique && mandat_dialog.valeur_energetique<=150  ' color="dark-grey"><span style="padding-left:3px">{{mandat_dialog.valeur_energetique}}</span></v-card>
                                                                </v-flex> 
                                                            </v-layout>
                                                            <v-layout row>
                                                                <v-flex xs6 pt-1>
                                                                    <v-card flat color="yellow"><v-layout row><v-flex pl-1 grow>151 à 230</v-flex><v-flex shrink pr-1>D</v-flex></v-layout></v-card>
                                                                </v-flex>
                                                                <v-flex xs2 pl-1 pt-1>
                                                                    <v-card flat dark v-if='150<mandat_dialog.valeur_energetique && mandat_dialog.valeur_energetique<=230  ' color="dark-grey"><span style="padding-left:3px">{{mandat_dialog.valeur_energetique}}</span></v-card>
                                                                </v-flex> 
                                                            </v-layout>
                                                            <v-layout row>
                                                                <v-flex xs7 pt-1>
                                                                    <v-card flat color="amber"><v-layout row><v-flex pl-1 grow>231 à 330</v-flex><v-flex shrink pr-1>E</v-flex></v-layout></v-card>
                                                                </v-flex>
                                                                <v-flex xs2 pl-1 pt-1>
                                                                    <v-card flat dark v-if='230<mandat_dialog.valeur_energetique && mandat_dialog.valeur_energetique<=330  ' color="dark-grey"><span style="padding-left:3px">{{mandat_dialog.valeur_energetique}}</span></v-card>
                                                                </v-flex> 
                                                            </v-layout>
                                                            <v-layout row>
                                                                <v-flex xs8 pt-1>
                                                                    <v-card flat color="orange"><v-layout row><v-flex pl-1 grow>331 à 450</v-flex><v-flex shrink pr-1>F</v-flex></v-layout></v-card>
                                                                </v-flex>
                                                                <v-flex xs2 pl-1 pt-1>
                                                                    <v-card flat dark v-if='330<mandat_dialog.valeur_energetique && mandat_dialog.valeur_energetique<=450  ' color="dark-grey"><span style="padding-left:3px">{{mandat_dialog.valeur_energetique}}</span></v-card>
                                                                </v-flex> 
                                                            </v-layout>
                                                            <v-layout row>
                                                                <v-flex xs9 pt-1>
                                                                    <v-card flat color="red"><v-layout row><v-flex pl-1 grow>≥451</v-flex><v-flex shrink pr-1>G</v-flex></v-layout></v-card>
                                                                </v-flex>
                                                                <v-flex xs2 pl-1 pt-1 v-if='450<mandat_dialog.valeur_energetique  '>
                                                                    <v-card flat dark color="dark-grey"><span style="padding-left:3px">{{mandat_dialog.valeur_energetique}}</span></v-card>
                                                                </v-flex> 
                                                            </v-layout>
                                                        </v-layout>
                                                    </v-card-text>  
                                                </v-card>
                                            </v-flex>
                                            <v-flex md12 xl6>
                                                <v-card flat>
                                                    <v-card-title class="text-uppercase dark-grey--text">Classe GES</v-card-title>
                                                    <v-card-text>  
                                                        <v-text-field v-model="mandat_dialog.valeur_ges" v-if="!edit" :mask=mask_number label="Classe GES"></v-text-field>  
                                                        <v-layout column v-if="mandat_dialog.valeur_ges!=''">
                                                            <v-layout row wrap>
                                                                <v-flex xs3>
                                                                <v-card flat color="purple lighten-5"><v-layout row><v-flex pl-1 grow>≤5</v-flex> <v-flex shrink pr-1>A</v-flex></v-layout></v-card>
                                                                </v-flex>
                                                                <v-flex xs2 pl-1>
                                                                <v-card flat dark v-if="mandat_dialog.valeur_ges<=5" color="dark-grey"><span style="padding-left:3px">{{mandat_dialog.valeur_ges}}</span></v-card>
                                                                </v-flex>
                                                            </v-layout> 
                                                            <v-layout row>
                                                                <v-flex xs4 pt-1>
                                                                    <v-card flat color="purple lighten-4"><v-layout row><v-flex pl-1 grow>6 à 10</v-flex><v-flex shrink pr-1>B</v-flex></v-layout></v-card>
                                                                </v-flex>
                                                                <v-flex xs2 pl-1 pt-1>
                                                                    <v-card flat dark v-if='mandat_dialog.valeur_ges>5 && mandat_dialog.valeur_energetique<=10' color="dark-grey"><span style="padding-left:3px">{{mandat_dialog.valeur_ges}}</span></v-card>
                                                                </v-flex> 
                                                            </v-layout>
                                                            <v-layout row>
                                                                <v-flex xs5 pt-1>
                                                                    <v-card flat color="purple lighten-3"><v-layout row><v-flex pl-1 grow>11 à 20</v-flex><v-flex shrink pr-1>C</v-flex></v-layout></v-card>
                                                                </v-flex>
                                                                <v-flex xs2 pl-1 pt-1>
                                                                    <v-card flat dark  v-if='10<mandat_dialog.valeur_ges && mandat_dialog.valeur_ges<=20' color="dark-grey"><span style="padding-left:3px">{{mandat_dialog.valeur_ges}}</span></v-card>
                                                                </v-flex> 
                                                            </v-layout>
                                                            <v-layout row>
                                                                <v-flex xs6 pt-1>
                                                                    <v-card flat color="purple lighten-2"><v-layout row><v-flex pl-1 grow>21 à 35</v-flex><v-flex shrink pr-1>D</v-flex></v-layout></v-card>
                                                                </v-flex>
                                                                <v-flex xs2 pl-1 pt-1>
                                                                    <v-card flat dark v-if='20<mandat_dialog.valeur_ges && mandat_dialog.valeur_ges<=35' color="dark-grey"><span style="padding-left:3px">{{mandat_dialog.valeur_ges}}</span></v-card>
                                                                </v-flex> 
                                                            </v-layout>
                                                            <v-layout row>
                                                                <v-flex xs7 pt-1>
                                                                    <v-card flat color="purple lighten-1"><v-layout row><v-flex pl-1 grow>36 à 55</v-flex><v-flex shrink pr-1>E</v-flex></v-layout></v-card>
                                                                </v-flex>
                                                                <v-flex xs2 pl-1 pt-1>
                                                                    <v-card flat dark v-if='35<mandat_dialog.valeur_ges && mandat_dialog.valeur_ges<=55' color="dark-grey"><span style="padding-left:3px">{{mandat_dialog.valeur_ges}}</span></v-card>
                                                                </v-flex> 
                                                            </v-layout>
                                                            <v-layout row>
                                                                <v-flex xs8 pt-1>
                                                                    <v-card flat color="purple darken-1"><v-layout row><v-flex pl-1 grow>56 à 80</v-flex><v-flex shrink pr-1>F</v-flex></v-layout></v-card>
                                                                </v-flex>
                                                                <v-flex xs2 pl-1 pt-1>
                                                                    <v-card flat dark v-if='55<mandat_dialog.valeur_ges && mandat_dialog.valeur_ges<=80' color="dark-grey"><span style="padding-left:3px">{{mandat_dialog.valeur_ges}}</span></v-card>
                                                                </v-flex> 
                                                            </v-layout>
                                                            <v-layout row>
                                                                <v-flex xs9 pt-1>
                                                                    <v-card flat color="purple darken-2"><v-layout row><v-flex pl-1 grow>≥81</v-flex><v-flex shrink pr-1>G</v-flex></v-layout></v-card>
                                                                </v-flex>
                                                                <v-flex xs2 pl-1 pt-1 v-if='80<mandat_dialog.valeur_ges'>
                                                                    <v-card flat dark color="dark-grey"><span style="padding-left:3px">{{mandat_dialog.valeur_ges}}</span></v-card>
                                                                </v-flex> 
                                                            </v-layout>
                                                        </v-layout>
                                                    </v-card-text>
                                                </v-card>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-flex>             
                 </v-layout>
            </v-container>
            </v-form>
        </v-card-text>
        
        </div>
        
    </v-card>
    <v-dialog width="500px" v-model="delete_dialog" overflow-hidden><v-card><v-layout justify-center row wrap>
        <v-flex xs12 py-2><v-layout row wrap justify-center><v-flex shrink><span class="subheading font-weight-bold red--text text--darken-3">Voulez-vous vraiment supprimer cette photo ?</span></v-flex></v-layout></v-flex>
        <v-flex shrink py-2 v-if="mandat_dialog.photos.length>carrousselIndex"> <v-img width="400px" :src="mandat_dialog.photos[carrousselIndex].photo"></v-img></v-flex>
            
        <v-flex xs12 py-2><v-layout row wrap justify-space-around><v-flex shrink><v-btn color="red darken-2" dark @click="delete_image">Supprimer</v-btn></v-flex><v-flex shrink>
            <v-btn color="grey" @click="delete_dialog=false">Annuler</v-btn></v-flex></v-layout></v-flex></v-layout></v-card>
    </v-dialog>
    <v-dialog width="100%" flat v-model="loading">
        <app-loader />
    </v-dialog>
</div>
</template>
<style>


[class*="--is-disabled "] *{
    color: #424242 !important;
}

/*[class$="--is-disabled"] *   {
    color: green !important; 
}*/

</style>
<script>
import L from 'leaflet'
import values from '@/assets/values.json'
import router from "@/plugins/router"
import axios from 'axios'
import LoaderComponent from '@/components/comps/Loader.vue'
import { setTimeout } from 'timers';
import config from "../../config.json"

export default {
  props:['mandat_dialog','dialog','edit','hasBeenClosed','loading'],
  name: "MandatDescription",
  mounted() {
    this.checkLoggedIn();
    
  },
  updated(){
      if(this.hasBeenClosed){
          this.displaymap();
          this.$emit('mapLoaded');
      }
      if(this.carrousselIndex>=this.mandat_dialog.photos.length){
          this.carrousselIndex=0;
      }
  },
  components: {
      'app-loader' : LoaderComponent
  },
  methods: {
    pickFile () {
        this.$refs.image.click ()
    },
    onFilePicked (e) {
       
        const files = e.target.files
        if(files[0] !== undefined) {
             this.loading=true;
            const fr = new FileReader ()
            fr.readAsDataURL(files[0])
            fr.addEventListener('load', () => {
                var bodyFormData = new FormData();
                const file = new Blob([files[0]])
                console.log(files[0].name);
                bodyFormData.append('photo',file, files[0].name);
                bodyFormData.append('position', this.mandat_dialog.photos.length);
                bodyFormData.append('bien_associe', this.mandat_dialog.id);
                console.log(bodyFormData.values())
                axios({
                    method : 'post',
                    url: config.api.baseurl+'/api/photo-create',
                    headers: {'Authorization': 'JWT ' + this.$session.get('token')},
                    data: bodyFormData
                }).then(response => {
                    this.$emit('updateMandat');

                }).catch(e => {
                    console.log(e)
                });
            });
        }

    },
    checkLoggedIn() {
      this.$session.start();
      if (!this.$session.has("token")) {
        router.push("/auth");
      }
    },
    displaymap(){
      try{
        this.map = L.map(this.$refs['mymap'])
        this.map.setView([this.mandat_dialog.lon, this.mandat_dialog.lat], 13);
        L.marker([this.mandat_dialog.lon, this.mandat_dialog.lat]).addTo(this.map)
        L.tileLayer('https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png', {
            attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery ©  <a href="https://carto.com/attribution">CARTO</a>',
            maxZoom: 18,
        }).addTo(this.map);
      }catch(e){
        this.map.remove();
        this.map = L.map(this.$refs['mymap'])
        this.map.setView([this.mandat_dialog.lon, this.mandat_dialog.lat], 13);
        L.marker([this.mandat_dialog.lon, this.mandat_dialog.lat]).addTo(this.map)
        L.tileLayer('https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png', {
            attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery ©  <a href="https://carto.com/attribution">CARTO</a>',
            maxZoom: 18,
        }).addTo(this.map);
      }
    },
    
    closeDialog() {
      this.$emit('closeDialog');
    },
    updateCoord(){
        axios({
            method : 'get',
            url: 'https://api-adresse.data.gouv.fr/search/?q='+this.mandat_dialog.numero_rue+"+"+this.mandat_dialog.rue+"+"+this.mandat_dialog.code_postal+"+"+this.mandat_dialog.ville+"/",
            crossDomain: true
        })
        .then(response => {
        // JSON responses are automatically parsed.
        var coord=response.data['features'][0]['geometry']['coordinates'];
        this.mandat_dialog.lat = coord[0];
        this.mandat_dialog.lon = coord[1];
        this.displaymap();
        })
        .catch(e => {
            console.log(e);
        })
    },
    save_edit() {
      this.$emit('saveEdit',this.mandat_dialog);

    },
    enable_edit(){
      this.$emit('enableEdit');
    },
    delete_image(){
        this.loading=true;
        this.delete_dialog=false;
         axios({
            method : 'delete',
            url: config.api.baseurl+'/api/photo-delete/'+this.mandat_dialog.photos[this.carrousselIndex].id,
            headers: {'Authorization': 'JWT ' + this.$session.get('token')},
        }).then(response => {
            this.$emit('updateMandat');
            if(this.carrousselIndex>0){
                this.carrousselIndex=this.carrousselIndex-1;
            }
        }).catch(e => {
            console.log(e)
        });
    },
    photo_move_r(){
        this.loading=true;
        var l_photo= {'id':this.mandat_dialog.photos[this.carrousselIndex].id,'position':this.mandat_dialog.photos[this.carrousselIndex].position}
        var r_photo= {'id':this.mandat_dialog.photos[this.carrousselIndex+1].id,'position':this.mandat_dialog.photos[this.carrousselIndex+1].position}
        l_photo.position=l_photo.position+1;
        r_photo.position=r_photo.position-1;
        axios({
            method : 'patch',
            url: config.api.baseurl+'/api/photo-update/'+r_photo.id,
            headers: {'Authorization': 'JWT ' + this.$session.get('token')},
            data: r_photo
        }).then(response => {
           axios({
                method : 'patch',
                url: config.api.baseurl+'/api/photo-update/'+l_photo.id,
                headers: {'Authorization': 'JWT ' + this.$session.get('token')},
                data: l_photo
            }).then(response => {
                setTimeout(()=>{this.loading=false;},4000);
                this.$emit('updateMandat');
                
                this.carrousselIndex=this.carrousselIndex+1;

            }).catch(e => {
                console.log(e)
            });
        }).catch(e => {
            console.log(e)
        });
        
    },
    photo_move_l(){
        this.loading=true;
         var l_photo= {'id':this.mandat_dialog.photos[this.carrousselIndex-1].id,'position':this.mandat_dialog.photos[this.carrousselIndex-1].position}
        var r_photo= {'id':this.mandat_dialog.photos[this.carrousselIndex].id,'position':this.mandat_dialog.photos[this.carrousselIndex].position}
        l_photo.position=l_photo.position+1;
        r_photo.position=r_photo.position-1;
        axios({
            method : 'patch',
            url: config.api.baseurl+'/api/photo-update/'+r_photo.id,
            headers: {'Authorization': 'JWT ' + this.$session.get('token')},
            data: r_photo
        }).then(response => {
           axios({
                method : 'patch',
                url: config.api.baseurl+'/api/photo-update/'+l_photo.id,
                headers: {'Authorization': 'JWT ' + this.$session.get('token')},
                data: l_photo
            }).then(response => {
                this.$emit('updateMandat');
                
                    this.carrousselIndex=this.carrousselIndex-1;

            }).catch(e => {
                console.log(e)
            });
        }).catch(e => {
            console.log(e)
        });
        
    }
  },
  
  data(){
      return{  
        piece_headers: [
            {
            text: '',
            align: 'left',
            sortable: false,
            value: 'name'
            },
            { text: 'Pièce', value: 'nom_piece' },
            { text: 'Surface', value: 'surface' },
            { text: 'Exposition', value: 'exposition' }
        ],
        carrousselIndex:0,
        types_biens: values.types_biens,
        types_mandats: values.types_mandats,
        listeProcedures:values.listeProcedures,
        types_chauffage: values.types_chauffage,
        modes_chauffage: values.modes_chauffage,
        types_stationnements:values.types_stationnements,
        mask_prix:values.masks['prix'],
        mask_number:values.masks['number'],
        mask_cp:values.masks['code_postal'],
        rule_price:[v=> v >= 0 || 'Prix de vente < Net vendeur'],
        map:null,
        delete_dialog:false
        }
    }
}
</script>
